import React, { useState } from 'react';
import {storage, db} from "../firebase";
import { Modal, ModalBody } from "react-bootstrap";
import { FiCamera } from 'react-icons/fi';
const firebase = require('firebase');


function ImageUpload({username}) {
    const [image, setImage] = useState(null);
    const [progress, setProgress] = useState(0);
    const [caption, setCaption] = useState('');
    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    const handleChange = (e) => {
        if (e.target.files[0]) {
            setImage(e.target.files[0]);
        }
    };

    const handleUpload = () => {
        const uploadTask = storage.ref(`images/${image.name}`).put(image);

        uploadTask.on(
            "state_changed",
            (snapshot) => {
                const progress = Math.round(
                    (snapshot.bytesTransferred / snapshot.totalBytes) * 100
                );
                setProgress(progress);
            },
            (error) => {
                console.log(error)
            },
            () => {
                storage
                .ref("images")
                .child(image.name)
                .getDownloadURL()
                .then(url => {

                    db.collection("posts").add({
                        timestamp: firebase.firestore.FieldValue.serverTimestamp(),
                        caption: caption,
                        imageUrl: url,
                        username: username
                    });

                    setProgress(0);
                    setCaption("");
                    setImage(null);
                    setShow(false);
                })
            }
        )
    };

  return (

    <div>
          <button className="upload-btn" onClick={handleShow}>
          <FiCamera size={25} />
        </button>
    

<Modal show={show} onHide={handleClose} keyboard={false}>
    <Modal.Header closeButton>
      <Modal.Title>Upload</Modal.Title>
    </Modal.Header>

    <ModalBody>

      <div className="upload container d-flex flex-column align-items-center mt-5 mb-5">
        <form>
            <progress className="w-100" value={progress} max="100" />
            <input className="form-control mb-2" type="text" placeholder="Enter caption..." onChange={event => setCaption(event.target.value)} value={caption}/>
            <input type="file" accept="image/*" onChange={handleChange} />
        </form>
    

      <div>
          <button className="btn-sm btn-dark mt-3" onClick={handleUpload}>Upload</button>
      </div>
      
      </div>
    </ModalBody>
  </Modal>
    </div>
    
  );
}

export default ImageUpload;